/* eslint-disable camelcase */
import { PORTIONPAK, SMARTPAK } from "../../../constants/producttypes";
import { roundedToFixed } from "../../../utils/number";
import * as paymentMethods from "../../../views/shared/paymentmethods";

function convertPaymentMethod(paymentMethod) {
    if (paymentMethod === paymentMethods.CreditCard) {
        return 'credit card';
    }

    if (paymentMethod === paymentMethods.PayPal) {
        return 'paypal';
    }

    return 'unknown';
}

function booleanToYesNo(value) {
    return typeof value === 'boolean' && value ? 'yes' : 'no';
}

export function formatCartItemsForEvents(items) {
    if (!Array.isArray(items)) {
        throw new Error('formatCartItemsForEvents requires an array of items as an argument.');
    }

    const format = ({
        IsAutoShip,
        Brand,
        ProductId,
        ProductClassId,
        ProductClassName,
        ParentReportingCategory,
        ChildReportingCategory,
        Quantity,
        Price,
        ProductType,
        Discounts
    }) => {
        return {
            item_name: ProductClassName,
            item_id: (ProductClassId + 10000).toString(),
            item_variant: ProductId.toString(),
            item_brand: Brand,
            item_parent_reporting_category: ParentReportingCategory,
            item_child_reporting_category: ChildReportingCategory,
            item_autoship: booleanToYesNo(IsAutoShip),
            item_smartpak: booleanToYesNo(ProductType === SMARTPAK),
            price: Price.toString(),
            quantity: Quantity.toString(),
            coupon: Object.keys(Discounts || {}),
        };
    };

    return items
        .reduce((arr, item) => {
            const { IsAutoShip, SupplementViewModels, ProductType } = item;

            if (ProductType === SMARTPAK || item.ProductType === PORTIONPAK) {
                SupplementViewModels.forEach(product => {
                    arr.push(format({
                        ...product,
                        Price: roundedToFixed(product.DiscountedPrice, 2),
                        ProductType,
                        IsAutoShip
                    }));
                });
            } else {
                arr.push(format({
                    ...item,
                    Price: roundedToFixed(item.DiscountedUnitPrice, 2),
                    ProductType,
                    IsAutoShip
                }));
            }

            return arr;
        }, []);
}

export function formatConfirmationModel({ CostSummary, OrderId, ShippingService, PaymentMethod, CartItems }) {
    const { DiscountedItemSubTotal, DiscountSum, Discounts, Tax, Shipping } = CostSummary;

    return {
        value: roundedToFixed(parseFloat(DiscountedItemSubTotal?.replace('$', '')), 2),
        transaction_id: OrderId,
        coupon: Object.keys(Discounts),
        discount: roundedToFixed(parseFloat(DiscountSum?.replace('$', '')), 2),
        tax: roundedToFixed(parseFloat(Tax?.replace('$', '')), 2),
        shipping: roundedToFixed(parseFloat(Shipping?.replace('$', '')), 2),
        shipping_tier: ShippingService,
        payment_type: convertPaymentMethod(PaymentMethod),
        items: formatCartItemsForEvents(CartItems)
    };
}
